module.exports = __webpack_public_path__ + "img/gandalf.b82756bc.png";